
import { Component, ElementRef } from "@angular/core";
import { Broadcaster } from "../../service/Broadcaster";
import { SingService } from "../../service/sing.service";
import { Dashboard } from "../../class/dashboard/dashboard";

@Component({
    selector: "dashboard-app",
    templateUrl: "html/dashboard.html",
    styleUrls: ["css/dashboard.css"], //left-menu/style.min.css
    providers: [SingService]
})
export class DashboardComponent {

    constructor(
        private broadcaster: Broadcaster,
        private elementRef: ElementRef

    ) { }

    ngOnInit() {

        this.broadcaster.on<any>("showDasboard").subscribe((data:Dashboard) => {
            this.elementRef.nativeElement.querySelector("#dasboard").src = data.url;
        });
    }
    UpdateHeightIframe() {
        return `${(window.innerHeight - 160)}px`;
    }


}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard/dashboard.ts